import { render, staticRenderFns } from "./LinkHandlerModule.vue?vue&type=template&id=107f5038"
import script from "./LinkHandlerModule.vue?vue&type=script&lang=js"
export * from "./LinkHandlerModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports